import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import React from "react";

const HeroSection: React.FC = () => {
  const scrollToGallery = () => {
    document.getElementById("gallery")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", inset: 0, overflow: "hidden" }}>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: "url(/images/202412/skeleton.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.18)",
            transform: "scale(1.05)",
          }}
        />
      </Box>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{
          textAlign: "center",
          zIndex: 2,
          padding: "0 24px",
          maxWidth: 900,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "clamp(2.5rem, 6vw, 6rem)",
            lineHeight: 1,
            mb: 2,
          }}
        >
          Framed Ghosts
        </Typography>

        <Box
          sx={{
            width: 60,
            height: "120px",
            backgroundColor: "#c9a84c",
            mx: "auto",
            my: 3,
          }}
        />

        <Typography
          variant="subtitle1"
          sx={{
            color: "#9e9e9e",
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            fontSize: { xs: "0.7rem", md: "0.85rem" },
            mb: 5,
            fontFamily: '"Inter", sans-serif',
          }}
        >
          Original Artworks by Kathy Su
        </Typography>

        <Button
          variant="outlined"
          onClick={scrollToGallery}
          sx={{
            borderColor: "#c9a84c",
            color: "#c9a84c",
            fontFamily: '"Inter", sans-serif',
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            px: 4,
            py: 1.5,
            borderRadius: 0,
            "&:hover": {
              backgroundColor: "rgba(201,168,76,0.08)",
              borderColor: "#c9a84c",
            },
          }}
        >
          View Works
        </Button>
      </motion.div>

      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        style={{ position: "absolute", bottom: 32, zIndex: 1 }}
      >
        <KeyboardArrowDownIcon sx={{ color: "#9e9e9e", fontSize: 32 }} />
      </motion.div>
    </Box>
  );
};

export default HeroSection;
